import React, { useCallback } from 'react';
import { connect } from 'react-redux';
import {
  FaTrash as TrashIcon,
  FaPen as EditIcon,
} from 'react-icons/fa';

import { BaseContext } from '../../../shared/gridEdit/columnDefinitionsUtils';
import { isEditingMode, RowWithMetadata } from '../../../shared/gridEdit/useEditableGridLogic';
import ValidationMessagesCellRenderer from '../../../shared/gridEdit/validationMessagesCellRenderer.component';
import { YesNoFlag } from '../../../shared/types';
import { showDeleteScenarioMemberModal } from './store/actions';
import { ScenarioMember } from '../../../shared/queries/scenarios';

type ScenarioMemberAdminColumnRendererProps = {
    data: RowWithMetadata<ScenarioMember>,
    rowIndex: number,
    showDeleteScenarioMemberModal: (arg: { entityToRemove: ScenarioMember, rowIndex: number }) => void,
    context: BaseContext & { isScenarioLocked: boolean },
    editRow: (row: RowWithMetadata<ScenarioMember>) => void,
}

const isScenarioMemberRowEdited = ({
  editedRowId,
  scenarioMember,
}: {
  editedRowId?: string,
  scenarioMember: RowWithMetadata<ScenarioMember>
}) => scenarioMember.meta.isAdded || scenarioMember.companyCode === editedRowId;

const ScenarioMemberAdminColumnRenderer = (props: ScenarioMemberAdminColumnRendererProps) => {
  const {
    data: scenarioMember,
    rowIndex,
    showDeleteScenarioMemberModal,
    context: {
      mode,
      editedRowId,
      isScenarioLocked,
    },
    editRow,
  } = props;

  const onEditClick = useCallback(() => {
    editRow(scenarioMember);
  }, [editRow, scenarioMember]);

  const onDeleteClick = useCallback(() => {
    showDeleteScenarioMemberModal({ entityToRemove: scenarioMember, rowIndex });
  }, [showDeleteScenarioMemberModal, scenarioMember, rowIndex]);

  const isEditDisabled = isEditingMode(mode) || isScenarioLocked;
  const isRemoveDisabled = isEditingMode(mode) || scenarioMember.added !== YesNoFlag.Y || isScenarioLocked;

  if (isEditingMode(mode) && isScenarioMemberRowEdited({ editedRowId, scenarioMember })) {
    return <ValidationMessagesCellRenderer {...props}/>;
  }

  return (
    <div>
      <button
        className="cell-icon-button"
        title="Edit Scenario Member"
        onClick={onEditClick}
        disabled={isEditDisabled}
      >
        <EditIcon size={16} className="cell-icon disabled-visible" />
      </button>
      <button
        className="cell-icon-button"
        title="Remove Scenario Member"
        onClick={onDeleteClick}
        disabled={isRemoveDisabled}
      >
        <TrashIcon size={16} className="cell-icon disabled-visible" />
      </button>
    </div>
  );
};

export default connect(null, {
  showDeleteScenarioMemberModal,
})(ScenarioMemberAdminColumnRenderer);
